import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from './app/ErrorBoundary';
import { SessionProvider } from './app/session';
import { ToastProvider } from './app/ToastProvider';
import { queryClient } from './app/queryClient';
import { router } from './routes/routes';
import '@kioskforge/blocks/preview.css';
import './theme/base.css';

const mount = document.getElementById('root');
if (!mount) throw new Error('Root element not found');

createRoot(mount).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <SessionProvider>
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </SessionProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>
);
